const DEFAULT_CLOUDFRONT_URL = 'https://d30lxkk358dph1.cloudfront.net';

/**
 * Ensures an image URL is absolute. When CLOUDFRONT_URL is unset on the
 * server, Rails string interpolation produces relative paths starting with
 * "/production/..." or "/development/...". This helper detects that pattern
 * and prepends the CloudFront domain.
 */
export function ensureAbsoluteImageUrl(url) {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/production/') || url.startsWith('/development/')) {
    return `${DEFAULT_CLOUDFRONT_URL}${url}`;
  }
  return url;
}

/**
 * Processes an image URL object (with keys like original, large, small, tiny)
 * ensuring all nested URLs are absolute.
 */
export function ensureAbsoluteImageUrls(urlObj) {
  if (!urlObj || typeof urlObj !== 'object') return urlObj;
  const result = {};
  for (const key of Object.keys(urlObj)) {
    const val = urlObj[key];
    if (typeof val === 'string') {
      result[key] = ensureAbsoluteImageUrl(val);
    } else if (val && typeof val === 'object' && val.url) {
      result[key] = { ...val, url: ensureAbsoluteImageUrl(val.url) };
    } else {
      result[key] = val;
    }
  }
  return result;
}
